export default "__VITE_ASSET__8b15e2bc__"